var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isError } from "@appsignal/core";
function windowEventsPlugin(options) {
    var ctx = window;
    var opts = __assign({ onerror: true, onunhandledrejection: true }, options);
    return function () {
        var self = this;
        var prev = {
            onError: ctx.onerror,
            unhandledRejection: ctx.onunhandledrejection
        };
        function _onErrorHandler(event, source, lineno, colno, error) {
            var span = self.createSpan();
            if (typeof event === "string" &&
                lineno === 0 &&
                /Script error\.?/.test(event)) {
                console.warn("[APPSIGNAL]: Cross-domain or eval script error detected, error ignored");
            }
            else {
                if (error) {
                    span.setError(error);
                }
                else {
                    span.setError({
                        name: "Error",
                        message: typeof event === "string"
                            ? event
                            : 'An HTML onerror="" handler failed to execute',
                        stack: "at ".concat(source, ":").concat(lineno).concat(colno ? ":".concat(colno) : "")
                    });
                }
                self.send(span);
            }
            if (typeof prev.onError === "function") {
                prev.onError.apply(this, arguments);
            }
        }
        function _onUnhandledRejectionHandler(event) {
            var span = self.createSpan();
            var error;
            if (event && event.reason && isError(event.reason)) {
                error = event.reason;
            }
            else {
                error = {
                    name: "UnhandledPromiseRejectionError",
                    message: _reasonFromEvent(event)
                };
            }
            span.setError(error);
            self.send(span);
            if (typeof prev.unhandledRejection === "function") {
                prev.unhandledRejection.apply(this, arguments);
            }
        }
        if (opts.onerror) {
            ctx.onerror = _onErrorHandler;
        }
        if (opts.onunhandledrejection) {
            ctx.onunhandledrejection = _onUnhandledRejectionHandler;
        }
    };
    function _reasonFromEvent(event) {
        if (!event || !event.reason) {
            return "";
        }
        if (typeof event.reason === "string") {
            return event.reason;
        }
        return JSON.stringify(event.reason, circularReplacer());
    }
    function circularReplacer() {
        var seenValue = [];
        var seenKey = [];
        return function (key, value) {
            if (typeof value === "object" && value !== null) {
                var i = seenValue.indexOf(value);
                if (i !== -1) {
                    return "[cyclic value: ".concat(seenKey[i] || "root object", "]");
                }
                else {
                    seenValue.push(value);
                    seenKey.push(key);
                }
            }
            return value;
        };
    }
}
export var plugin = windowEventsPlugin;
